<template>
	<div class="crowdfunding-camapaign fundraising-camapaign">
		<!-- BIG SLOGAN -->
		<div class="container">
			<p class="crowd-or-rais">
				<router-link to='/crowdfunding' class="domore-blue-1">CROWDFUNDING</router-link>
				<span class="or">/</span>
				<router-link to='/fundraising' class="rais-or">FUNDRAISING</router-link>
			</p>
			<h1 class="big-slogan-blue mb-30">{{ $t("project.slogan") }}</h1>
		</div><!-- .container -->

		<!-- CAMPAIGN -->
    <basics :project="project"></basics>

		<!-- CAMPAIGN DETAILS -->
		<div class="container campaign-details crowd">
			<div class="row">
				<div class="col-md-9">
          <!-- Story, Author, Backers tabs -->
          <project-details :project="project"></project-details>
				</div><!-- .col-md-9 -->

        <!-- Rewards -->
        <div class="col-md-3">
          <div class="all-categories mb-20">
            <strong>{{ $t("rewards") }}</strong>
          </div>
          <reward v-if="project.id"
            v-for="reward in rewards"
            :key="reward.id"
            :reward='reward'
            :project='project'>
          </reward>
          <p v-if="!rewards.length" class="center">{{ $t('project.hasNoRewards') }}</p>
        </div><!-- Rewards -->
			</div><!-- .row -->

      <!-- Verify or publish project -->
      <verify-project :project='project' class="mt-50"></verify-project>
		</div><!-- .container campaign-details crowd -->

		<!-- STAR BOX -->
		<div class="container mt-50 mb-50">
			<p class="center"><img src="~assets/img/star.png"></p>
		</div><!-- .container .mt-50 .mb-50 -->

		<!-- FUNDRAISING OTHER CAMPAIGNS YOU MIGHT LIKE -->
		<div class="container mb-30">
			<div class="all-categories mb-20">
				<strong>{{ $t("project.fundraising") }}: </strong>{{ $t("project.show.otherCampaigns") }}
			</div>
			<div class="row">
        <fundraising-tile v-for="project in projects" :key="project.id" :project="project" size='col-md-4'></fundraising-tile>
			</div><!-- .row -->
		</div><!-- .container .mb-30 -->

		<!-- FUNDRAISING ALL CATEGORIES -->
		<div class="container mb-30">
			<div class="all-categories">
				<strong>{{ $t("project.fundraising") }}:</strong>{{ $t("project.allCategories") }}
			</div>
			<div class="all-categories-list-crowd">
				<ul class="list-inline">
          <li v-for="(category, i) in categories" :key="i">
						<router-link :to="{ path: '/fundraising', query: { category: category.name } }">{{ category.name }}</router-link>
					</li>
				</ul>
			</div><!-- .all-categories-list-crowd -->
		</div><!-- .container .mb-30 -->
	</div>
</template>

<script>
// API
import projectsApi from '@/api/v1/projects';
import rewardsApi from '@/api/v1/rewards';
// Components
import Alert from '@/components/Alert';
import FundraisingTile from '@/components/Project/Tiles/Fundraising';
import Reward from '@/components/Reward/Contribute';
import Basics from '@/components/Project/Show/Basic';
import ProjectDetails from '@/components/Project/Show/Details';
import VerifyProject from '@/components/Project/Verification';
// Mixins
import showProject from '@/mixins/showProject';

export default {
  mixins: [showProject],
  components: { Alert, FundraisingTile, Reward, Basics, ProjectDetails, VerifyProject },
  data() {
    return {
      projects: [],
      categories: [],
      rewards: [],
      success: '',
    };
  },
  created() {
    projectsApi.getFundraisingProjects((projects) => { this.projects = projects; });
    projectsApi.getCategories((categories) => { this.categories = categories; }, false);
    rewardsApi.getRewards(this.$route.params.id, (rewards) => { this.rewards = rewards; });
  },
};
</script>



// WEBPACK FOOTER //
// Show.vue?e41dd434